// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"afc19907","37":"62e9e99b","918":"4b68e03b","943":"2b02f2a6","989":"fa8df1df"}[chunkId] + ".chunk.js";
};